module.exports = __webpack_public_path__ + "static/media/campaignTemplate.01a484cb.png";